const archive = () => {
    const archiveList = document.querySelector(".archive__list");
    const archiveDownload = document.querySelector(".archive__download");
    if (archiveList && archiveDownload) {
        const downloadImg = archiveDownload.querySelector(".archive__download-image");
        const downloadBtn = archiveDownload.querySelector(".archive__download-btn");
        archiveList.addEventListener("click", function(e) {
            if (e.target.dataset.hasOwnProperty("img") && e.target.dataset.hasOwnProperty("file")) {
                downloadImg.src = e.target.dataset.img;
                downloadBtn.href = e.target.dataset.file;
                archiveDownload.classList.add("open");
            }
        });
        archiveDownload.addEventListener("click", function(e) {
            if (e.target.classList.contains("archive__download") || e.target.classList.contains("archive__download-close")) {
                this.classList.remove("open");
            }
        });
    }
}
export default archive;
